module.exports = __webpack_public_path__ + "img/quanqiuv2.48666006.png";